
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host(:not([site='BH'])) h3 {
    margin:0px;
}
  :host(:not([site='BH'])) h3{
    font-size:inherit;
    line-height:inherit;
  }
  :host(:not([site='BH'])) .jumbo {
    position:relative;
}
  :host(:not([site='BH'])) .jumbo {
    background-size:contain;
}
  :host(:not([site='BH'])) .jumbo {
    background-repeat:no-repeat;
}
  :host(:not([site='BH'])) .jumbo {
    padding-top:210px;
}
  @media (min-width: 768px) {
    :host(:not([site='BH'])) .jumbo {
        background-size:cover;
    }
}
  @media (min-width: 768px) {
    :host(:not([site='BH'])) .jumbo {
        padding-top:0px;
    }
}
  @media (min-width: 1024px){
  :host(:not([site='BH'])) .jumbo{
      height:500px
  }
    }
  @media (min-width: 1280px){
  :host(:not([site='BH'])) .jumbo{
      height:735px
  }
    }
  :host(:not([site='BH'])) .jumbo-content-wrapper {
    height:100%;
}
  :host(:not([site='BH'])) .jumbo-content-wrapper {
    background-color:var(--neutral-white);
}
  @media (min-width: 768px) {
    :host(:not([site='BH'])) .jumbo-content-wrapper {
        background-color:var(--neutral-transparent);
    }
}
  @media (min-width: 768px) {
    :host(:not([site='BH'])) .jumbo-content-wrapper {
        padding-top:2.5rem;
        padding-bottom:2.5rem;
    }
}
  @media (min-width: 1024px) {
    :host(:not([site='BH'])) .jumbo-content-wrapper {
        display:flex;
    }
}
  @media (min-width: 1024px) {
    :host(:not([site='BH'])) .jumbo-content-wrapper {
        align-items:center;
    }
}
  :host(:not([site='BH'])) .jumbo-content-wrapper.right-align {
    justify-content:flex-end;
}
  :host(:not([site='BH'])) .jumbo-content-wrapper.left-align {
    justify-content:flex-start;
}
  :host(:not([site='BH'])) .jumbo-content-section {
    background-color:var(--neutral-white);
}
  :host(:not([site='BH'])) .jumbo-content-section {
    padding-top:1.5rem;
    padding-bottom:1.5rem;
}
  @media (min-width: 768px) {
    :host(:not([site='BH'])) .jumbo-content-section {
        border-radius:1rem;
    }
}
  @media (min-width: 768px) {
    :host(:not([site='BH'])) .jumbo-content-section {
        padding:1.75rem;
    }
}
  @media (min-width: 1024px) {
    :host(:not([site='BH'])) .jumbo-content-section {
        width:50%;
    }
}
  :host(:not([site='BH'])) .jumbo-headline {
    padding-bottom:0.625rem;
}
  :host(:not([site='BH'])) .jumbo-headline {
    font-family:var(--ff-display);
}
  :host(:not([site='BH'])) .jumbo-headline {
    font-size:var(--fs-h2-small);
    line-height:var(--lh-h2-small);
}
  :host(:not([site='BH'])) .jumbo-headline {
    font-weight:var(--fw-bold);
}
  :host(:not([site='BH'])) .jumbo-headline {
    color:var(--primary-blue);
}
  @media (min-width: 1024px) {
    :host(:not([site='BH'])) .jumbo-headline {
        padding-bottom:0.875rem;
    }
}
  @media (min-width: 1024px) {
    :host(:not([site='BH'])) .jumbo-headline {
        font-size:var(--fs-h2-medium);
        line-height:var(--lh-h2-medium);
    }
}
  @media (min-width: 1280px) {
    :host(:not([site='BH'])) .jumbo-headline {
        font-size:var(--fs-h2);
        line-height:var(--lh-h2);
    }
}
  :host(:not([site='BH'])) .jumbo-body-text {
    padding-bottom:0.875rem;
}
  :host(:not([site='BH'])) .jumbo-body-text {
    font-family:var(--ff-body);
}
  :host(:not([site='BH'])) .jumbo-body-text {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
}
  :host(:not([site='BH'])) .jumbo-body-text {
    color:var(--neutral-gray-1);
}
  @media (min-width: 1024px) {
    :host(:not([site='BH'])) .jumbo-body-text {
        padding-bottom:1.25rem;
    }
}

:host([site='BH']) .jumbo {
    background-image:var(--bh-gradient-gray-b-t);
}

:host([site='BH']) .jumbo {
    padding-top:0px;
}

:host([site='BH']) outline-container {
    height:100%;
}

:host([site='BH']) .jumbo-content-wrapper {
    padding:0px;
}

:host([site='BH']) .jumbo-content-wrapper {
    padding-top:4rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-content-section {
    display:flex;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-content-section {
    flex-direction:column;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-content-section {
    align-items:center;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-content-section {
    padding-left:1.25rem;
    padding-right:1.25rem;
}

@media (min-width: 1024px) {
    :host([site='BH']) .jumbo-content-wrapper .jumbo-content-section {
        width:100%;
    }
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image {
    display:flex;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image {
    width:100%;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image {
    overflow:hidden;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image {
    background-size:cover;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image {
    background-position:center;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image {
    background-repeat:no-repeat;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .image-wrapper {
    display:flex;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .image-wrapper {
    flex-shrink:0;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .image-wrapper {
    flex-grow:0;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .image-wrapper {
    flex-basis:100%;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .image-wrapper div, :host([site='BH']) .jumbo-content-wrapper .jumbo-image .image-wrapper picture, :host([site='BH']) .jumbo-content-wrapper .jumbo-image .image-wrapper img {
    width:100%;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .image-wrapper img {
    border-radius:0.5rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .inner-border {
    margin:1.25rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .inner-border {
    margin-bottom:1.5rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .inner-border {
    width:100%;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .inner-border {
    border-radius:0.5rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .inner-border {
    border-width:1px;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .inner-border {
    border-style:solid;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .inner-border {
    border-color:var(--bh-neutral-white);
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-image .inner-border{
        margin-left:calc(-100% + 1.25rem);
      }

:host([site='BH']) .jumbo-content-wrapper .jumbo-headline {
    padding-top:1.25rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-headline {
    padding-bottom:0.625rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-headline {
    font-family:var(--bh-ff-body);
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-headline {
    font-size:var(--bh-fs-heading-06);
    line-height:var(--bh-lh-heading-06);
    letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-headline {
    font-weight:var(--fw-light);
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-headline {
    color:var(--bh-neutral-darker);
}

@media (min-width: 1024px) {
    :host([site='BH']) .jumbo-content-wrapper .jumbo-headline {
        padding-top:4rem;
    }
}

@media (min-width: 1024px) {
    :host([site='BH']) .jumbo-content-wrapper .jumbo-headline {
        padding-bottom:0.875rem;
    }
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-body-text {
    padding-bottom:0.875rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-body-text {
    font-family:var(--bh-ff-body);
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-body-text {
    font-size:var(--bh-fs-heading-02);
    line-height:var(--bh-lh-heading-02);
    letter-spacing:var(--bh-ls-heading-02);
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-body-text {
    font-weight:var(--fw-normal);
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-body-text {
    color:var(--bh-neutral-darker);
}

@media (min-width: 1024px) {
    :host([site='BH']) .jumbo-content-wrapper .jumbo-body-text {
        padding-bottom:1.25rem;
    }
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-button {
    padding-top:1.25rem;
}

:host([site='BH']) .jumbo-content-wrapper .jumbo-button {
    padding-bottom:3rem;
}

@media (min-width: 1024px){
      :host([site='BH']) .jumbo-content-wrapper .jumbo-headline, :host([site='BH']) .jumbo-content-wrapper .jumbo-body-text {
        width:50%;
    }
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-content-section {
        flex-direction:row;
    }
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-content-section {
        flex-wrap:wrap;
    }
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-content-section {
        align-items:flex-start;
    }

        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
        padding-left:1.25rem;
    }

        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
        padding-right:0.75rem;
    }

        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
        padding-bottom:1.25rem;
    }

        @media (min-width: 768px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
            padding-left:2rem;
        }
    }

        @media (min-width: 768px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
            padding-right:1rem;
        }
    }

        @media (min-width: 768px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
            padding-bottom:2rem;
        }
    }

        @media (min-width: 1024px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
            padding-left:4rem;
        }
    }

        @media (min-width: 1024px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
            padding-right:2rem;
        }
    }

        @media (min-width: 1024px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-headline {
            padding-bottom:4rem;
        }
    }

        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
        padding-top:1.25rem;
    }

        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
        padding-right:1.25rem;
    }

        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
        padding-left:0.75rem;
    }

        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
        padding-bottom:1.25rem;
    }

        @media (min-width: 768px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
            padding-top:2rem;
        }
    }

        @media (min-width: 768px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
            padding-right:2rem;
        }
    }

        @media (min-width: 768px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
            padding-left:1rem;
        }
    }

        @media (min-width: 768px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
            padding-bottom:2rem;
        }
    }

        @media (min-width: 1024px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
            padding-top:4rem;
        }
    }

        @media (min-width: 1024px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
            padding-right:4rem;
        }
    }

        @media (min-width: 1024px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
            padding-left:2rem;
        }
    }

        @media (min-width: 1024px) {
        :host([site='BH']) .jumbo-content-wrapper.two-column .jumbo-body-text {
            padding-bottom:4rem;
        }
    }
    }
`;